export * from './cy'
export * from './page'
export * from './mixpanel'

export enum CommonType {
  All = 'All'
}

export enum Modal {
  DevMode = 'dev-mode'
}

export enum TradeHistoryHeaderType {
  Time = 'time'
}

export enum WasmExecuteMessageType {
  Swap = 'Swap'
}

export enum SpendPoolFilterSide {
  To = 'to',
  From = 'from'
}

export enum EventBus {
  UpdateGlobalStatus = 'update-global-status'
}

export enum TransactionTab {
  Message = 'message',
  EventLogs = 'eventlogs'
}

export enum AssetTab {
  Injective = 'injective',
  SmartContracts = 'smartcontracts'
}

export enum FundingRateHistoryInterval {
  TwelveHours = 'twelveHours',
  TwentyFourHours = 'twentyFourHours'
}

export enum WasmSwapExecuteMessageType {
  SwapMinOutput = 'swap_min_output',
  SwapExactOutput = 'swap_exact_output'
}

export enum StakingTab {
  Unbondings = 'unbondings',
  Delegations = 'delegations',
  Redelegations = 'redelegations'
}

export enum PageCategory {
  Trading = 'Trading',
  Network = 'Network',
  Ecosystem = 'Ecosystem',
  Developers = 'Developers'
}

export enum InjectionKey {
  SubaccountIdKey = 'subaccountIdKey',
  IsBalanceBreakdownEnabledKey = 'isBalanceBreakdownEnabledKey'
}

export enum Modal {
  WalletConnect = 'wallet-connect',
  TokenSelector = 'token-selector',
  WalletDisconnect = 'wallet-disconnect'
}

export enum AccountTab {
  Staking = 'staking',
  Balance = 'balances',
  Transaction = 'transactions',
  CW20Balances = 'cw20balances'
}

export enum AssetSelectorType {
  All = 'all',
  Ibc = 'ibc',
  Native = 'native',
  Cw20 = 'cosmWasm',
  BridgedERC20 = 'bridgedERC20'
}

export enum AssetHeaderType {
  Token = 'token',
  Price = 'price',
  CurrentSupply = 'current-supply',
  TotalUsdValue = 'total-usd-value'
}

export enum MarketInfoHeaderType {
  Type = 'type',
  Price = 'price',
  Volume = 'volume',
  Markets = 'markets',
  VolumeInUsd = 'volume-in-usd'
}

export enum DappCategory {
  Dex = 'DEX',
  DeFi = 'DeFi',
  Tools = 'Tools',
  NFTFi = 'NFTFi',
  SocialFi = 'SocialFi',
  AllCategory = 'All Category'
}

export enum SmartContractTab {
  Balance = 'balance',
  InitMsg = 'initMsg',
  CW20Balances = 'cw20balances',
  Transactions = 'transactions',
  DenomHolders = 'denomHolders'
}

export enum MarketsTab {
  MarketsInfo = 'marketsinfo',
  TradingRules = 'tradingrules',
  FundingRateHistory = 'fundingratehistory',
  RealtimeFundingRate = 'realtimefundingrate'
}

export enum MetaType {
  Code = 'Code',
  Block = 'Block',
  Codes = 'Codes',
  Blocks = 'Blocks',
  Markets = 'Markets',
  Contract = 'Contract',
  Contracts = 'Contracts',
  Transaction = 'Transaction',
  Transactions = 'Transactions'
}

export enum GlobalSearchType {
  Block = 'block',
  Denom = 'denom',
  Account = 'account',
  BlockHash = 'blockHash',
  Subaccount = 'subaccount',
  Transaction = 'transaction',
  EtherAccount = 'etherAccount',
  InjDomainName = 'injDomainName',
  InjBonfidaDomainName = 'injBonfidaDomainName'
}

export enum SearchStatusType {
  Valid = 'valid',
  BlockInvalid = 'blockInvalid',
  BlockNotFound = 'blockNotFound',
  AccountInvalid = 'accountInvalid',
  AccountNotFound = 'accountNotFound',
  ContractInvalid = 'contractInvalid',
  WasmCodeInvalid = 'wasmCodeInvalid',
  WasmCodeNotFound = 'wasmCodeNotFound',
  ContractNotFound = 'contractNotFound',
  TransactionNotFound = 'transactionNotFound',
  TransactionHashInvalid = 'invalidTransactionHash'
}

export enum StatusKey {
  JsonStatus = 'JsonStatus',
  GlobalStatus = 'GlobalStatus',
  TxsInitStatus = 'TxsInitStatus',
  SpotInitStatus = 'SpotInitStatus',
  BlocksInitStatus = 'BlocksInitStatus',
  ParamsInitStatus = 'ParamsInitStatus',
  NetworkInitStatus = 'NetworkInitStatus',
  PortfolioInitStatus = 'PortfolioInitStatus',
  UsdPricesInitStatus = 'UsdPricesInitStatus',
  DerivativeInitStatus = 'DerivativeInitStatus',
  TotalSupplyInitStatus = 'TotalSupplyInitStatus',
  AccountStakingInitStatus = 'AccountStakingInitStatus',
  AccountPositionsInitStatus = 'AccountPositionsInitStatus',
  isBalanceBreakdownEnabledKey = 'isBalanceBreakdownEnabledKey'
}

export enum NetworkErrorType {
  DenomHolders = 'denomHolders',
  TradeHistory = 'tradeHistory',
  AssetDetailsPage = 'AssetDetailsPage',
  BlockDetailsPage = 'blockDetailsPage',
  BlocksPageBlocks = 'blocksPageBlocks',
  WasmCodePageCodes = 'wasmCodePageCodes',
  AccountDetailsPage = 'AccountDetailsPage',
  AccountPageStaking = 'accountPageStaking',
  CommunitySpendPool = 'communitySpendPool',
  ContractDetailsPage = 'contractDetailsPage',
  WasmCodeDetailsPage = 'wasmCodeDetailsPage',
  GenericNoRecordsFound = 'genericNoRecordsFound',
  ContractsPageContracts = 'contractsPageContracts',
  TransactionDetailsPage = 'transactionDetailsPage',
  AccountPageTransactions = 'accountPageTransactions',
  AccountPageBankBalances = 'accountPageBankBalances',
  AccountPageCW20Balances = 'accountPageCW20Balances',
  ContractPageTransactions = 'contractPageTransactions',
  ContractsPageAccountsBalance = 'contractsPageAccountsBalance',
  TransactionsPageTransactions = 'transactionsPageTransactions',
  AccountPageSubaccountBalances = 'accountPageSubaccountBalances'
}
